
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Auth} from 'aws-amplify';

import {CognitoUserInterface, AuthState} from '@aws-amplify/ui-components';

import { GetenvironmentsService, Environments } from 'src/app/services/getenvironments.service';
import { GetusuariosService, Usuarios } from 'src/app/services/getusuarios.service';

@Component({
  selector: 'app-pagina-main-care',
  templateUrl: './pagina-main-care.component.html',
  styleUrls: ['./pagina-main-care.component.scss']
})
export class PaginaMainCareComponent implements OnInit {

  DEBUG: boolean = false;
  
  response: any;
  datomm: any = {};

  array_tab_usuarios: Usuarios[] = [];
  array_tab_environments: Environments[] = [];
  arry_usuarios: string [] = [];
  carer:string;
  group:string;

  userid: string;
  timeini: number;
  timefin: number;

  user: CognitoUserInterface | undefined;
  authState: AuthState;

  flagUsuarios: boolean = false;

  constructor(
    private getusuariosService: GetusuariosService, 
    private router: Router, 
    private zone: NgZone
    ) { 
      // OBTENEMOS el dato pasado por navigation Usuario del cuidador
      if(this.router.getCurrentNavigation().extras.state != undefined){
        this.carer = this.router.getCurrentNavigation().extras.state.carer; 
        this.group = this.router.getCurrentNavigation().extras.state.group; 
      }else{
        console.log("MAIN CARE volvemos")
        this.router.navigate(['/login-aws']);
      }

    }

  ngOnInit() {  
    Auth.currentAuthenticatedUser({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  }).then(user => {
      
      this.group = user.signInUserSession.accessToken.payload["cognito:groups"][0];

    }
  ).catch(err => console.log(err));

    //Obtenemos el cuidador/medico pasado por route
    if(this.DEBUG){
      console.log("CUIDADOR/MEDICO: " + this.carer + " - " + this.group);

      // Cargamos los usuarios a cargo del cuidador
      console.log("API - asyncMethodUsuarios:");
    }

    this.asyncMethodUsuarios(); 

  }

  

  async asyncMethodUsuarios() {
    //Obtenemos los datos del usuario
    // const { groups } = await Auth.currentAuthenticatedUser();
    // console.log("atributos: " + groups);

    if(this.DEBUG){
      console.log("SERVICE USUARIOS: " + this.carer);
    }
    this.array_tab_usuarios = await this.getusuariosService.getUsuarios(this.carer);
    if(this.DEBUG){
      console.log (this.array_tab_usuarios);
    }
    this.flagUsuarios = true;
  }


  loadMainUser(arrayUser){
    if(this.DEBUG){
      console.log("LoadMainUser " + arrayUser.userid);
    }
    
    this.router.navigate(['/main-user', arrayUser.nombre], {state: {arrayUser: arrayUser, group: this.group}}); 
  }


  async signOut(){
    try {
      await Auth.signOut();
      // Hub.dispatch('UI Auth', {   // channel must be 'UI Auth'
      //       event: 'AuthStateChange',    // event must be 'AuthStateChange'
      //       message: 'signedout'    // message must be 'signedout'
      //   });
      if(this.DEBUG){
        console.log('signOut');
      }
      this.router.navigate(['/login-aws']);
    } catch (error) {
      if(this.DEBUG){
        console.log('error signing out: ', error);
      }
    }
  }

}
